module.exports = __webpack_public_path__ + "static/media/shandong-logo.37540aac.png";